class Colors {
    static PRIMARY_COLOR = '#04619E';
    static ACCENT_COLOR = '#72BE46';
}

export default Colors;